import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Stack from '@mui/joy/Stack';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import Textarea from '@mui/joy/Textarea';

import { CollabProps } from 'stores/collab_store';
import { FileType } from 'stores/file_store';
import FileUpload from 'components/FileUpload';
import Error from 'components/Error';

import useCollabs from 'hooks/useCollabs';
import useFileAssociation from 'hooks/useFileAssociation';
import useUserIdentity from 'hooks/useUserIdentity';
import { Success } from './FancyToast';
import useCollabInvite from 'hooks/useCollabInvite';

const SupportMeCreate = () => {
    const [searchParams] = useSearchParams();
    const { createCollab } = useCollabs();
    const { associate } = useFileAssociation();
    const { inviteSupport } = useCollabInvite();
    const { currentIdentity } = useUserIdentity();
    const [description, setDescription] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [files, setFiles] = useState<FileType[]>([] as FileType[]);
    const [uploadUuid, setUploadUuid] = useState<number>(0);
    const [background, setBackground] = useState('');

    const navigate = useNavigate();

    const feedback = searchParams.get('feedback');
    const slug = searchParams.get('slug');
    const init = searchParams.get('init');
    useEffect(() => {
        if (slug) {
            const url = `${window.location.protocol}//${window.location.host}/lore/${slug}`;
            setBackground(`\n\nFeedback related to: ${slug}\n${url}`);
        }
    }, [feedback, slug]);



    const handleSubmit = async () => {
        if(isUploading) {
            Error("Please wait for the files to finish uploading");
            return;
        }
        const collab = await createCollab({
            project: '',
            identity: currentIdentity.uuid,
            title: '',
            description: description + (background ? `\n\n${background}` : ''),
            variant: 'support',
        } as CollabProps);

        if (files.length) {
            files.forEach(async (f) => {
                await associate(currentIdentity.uuid, f.uuid, 'collab', collab.uuid);
            });
        }

        await inviteSupport(collab.uuid, currentIdentity?.uuid);

        Success('Support request submitted');

        setDescription('');
        setUploadUuid(uploadUuid + 1);
        setFiles([] as FileType[]);
        navigate(`/support/${collab.uuid}`);
    };

    function handleFilesChange(f: FileType[]) {
        setFiles(f);
    }

    return (
        <Stack
            m={1}
            spacing={2}
        >


            {!init &&
                <>
                    <Stack>
                        <Typography level="title-lg">Get support, report a bug, or submit feedback</Typography>
                        <Typography level="body-xs">
                            This will go directly to our founder.
                        </Typography>
                    </Stack>

                    <Typography
                        level="title-md"
                    >
                        What can we help you with?
                    </Typography>
                </>
            }

            <Stack spacing={2}>

            <FileUpload
                defaultFilesUploaded={files}
                uploadUuid={uploadUuid}
                setIsUploading={setIsUploading}
                onFilesUploaded={handleFilesChange}
            />

                <Textarea
                    minRows={5}
                    // html input attribute
                    onChange={(e) => { setDescription(e.target.value); }}
                    value={description}
                    name="description"
                    placeholder="&quot; Nothing happens when I click on Account. &quot;"
                />

                <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="space-between"
                >
                    <Button
                        variant="plain"
                        onClick={() => window.history.back()}
                    >Back</Button>
                    <Button
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </Stack>
            </Stack>

        </Stack>
    );
}
export default SupportMeCreate;
